// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"25416e94","732":"fde3e436","977":"68fa071e"}[chunkId] + ".chunk.js";
};